import { mergeDateTime } from '@utils/Date';
import { isAfter } from 'date-fns';
import * as z from 'zod';

export const CREATE_SWING_VOTE_SCHEMA = z
  .object({
    selected: z.string().optional(),
    updatePeriod: z.boolean().optional(),
    period: z.object({
      immediate: z.boolean(),
      focusedInput: z.enum(['startDate', 'endDate']).nullable(),
      startDate: z.date(),
      endDate: z.date(),
      startTime: z.date(),
      endTime: z.date(),
    }),
  })
  .refine(
    (data) => {
      const start = mergeDateTime(
        data.period.startDate,
        data.period.immediate ? new Date() : data.period.startTime
      );
      const end = mergeDateTime(data.period.endDate, data.period.endTime);
      return isAfter(end, start);
    },
    {
      message: 'Poll end must be after start',
      path: ['period.endDate'],
    }
  );

export type CreateSwingVoteData = z.infer<typeof CREATE_SWING_VOTE_SCHEMA>;
